// Using a string enum is safer than a numeric one.
export enum ButtonVariantEnum {
  Primary = 'primary',
  Secondary = 'secondary',
  Danger = 'danger',
  Ghost = 'ghost',
}

export enum ButtonSize {
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
}

export enum AlertType {
  ERROR = 'error',
  SUCCESS = 'success',
  INFO = 'info',
  WARNING = 'warning',
}

export enum StarRatingSize {
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
}

export enum StarRatingVariant {
  Default = 'default',
  Accent = 'accent',
}

export enum MediaCountIndicatorVariant {
  Carousel = 'carousel',
  Thumbnail = 'thumbnail',
}
export enum NotificationBannerTypes {
  Inline = 'inline',
  Callout = 'callout',
  Toast = 'toast',
}
export enum NotificationBannerVariants {
  Low = 'low',
  High = 'high',
  FullScreen = 'fullScreen',
}
export enum NotificationBannerStates {
  Success = 'success',
  Error = 'error',
  Info = 'info',
  Warning = 'warning',
}
export enum NotificationBannerToastTimers {
  Short = 'short',
  Long = 'long',
}

export enum DialogVariantEnum {
  Default = 'default',
  Fullscreen = 'fullscreen',
  Modal = 'modal',
}

export enum PositionEnum {
  Top = 'top',
  Bottom = 'bottom',
  Left = 'left',
  Right = 'right',
}

// Using a string enum is safer than a numeric one.
export enum IconButtonVariantEnum {
  Filled = 'filled',
  Outlined = 'outlined',
  Ghost = 'ghost',
}
